import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';

function ScanVolumeByProcedureChart() {
    return (
        <section className="dashboard-chart-card">
            <div className="dashboard-chart-header dashboard-chart-header--with-icon">
                <h2>Scan Volume by Procedure</h2>
                <Tooltip title="These analytics will be available in a future update.">
                    <InfoOutlinedIcon className="dashboard-chart-info-icon" fontSize="small" />
                </Tooltip>
            </div>
            <div className="dashboard-chart-body">
                <div className="dashboard-chart-empty">
                    <p>Coming soon.</p>
                    <p>These analytics will be available in a future update.</p>
                </div>
            </div>
        </section>
    );
}

export default ScanVolumeByProcedureChart;
